import { NgModule } from '@angular/core';
import { FiErrorMessageComponent } from './fi-error-message.component';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiErrorMessageDirective } from '@fi-shared/fi-error-message/fi-error-message.directive';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [FiErrorMessageComponent, FiErrorMessageDirective],
    exports: [FiErrorMessageComponent, FiErrorMessageDirective],
})
export class FiErrorMessageModule {}
